import { useMsal } from "@azure/msal-react";
import { useMutation } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";

// S2 endpoint — group notifications
const API_END_POINT = "group/admin/notify/";

export interface GroupNotification {
	Method: "push" | "email";
	Title: string;
	Body: string;
	Groups: string[];
	SendAt?: string;
	From?: string;
}

/**
 * Hook to notify groups via S2 API.
 */
export function useGroupNotify() {
	const { instance } = useMsal();

	const mutation = useMutation({
		mutationFn: async (notification: GroupNotification) => {
			// S2 uses "push" (S1 used "send")
			const request_type =
				notification.Method === "push" ? "push" : "email";
			const request: Record<string, unknown> = {
				Title: notification.Title,
				Body: notification.Body,
				Groups: notification.Groups,
			};
			if (request_type === "email" && notification.From === "ce") {
				request["From"] = "ce";
			}
			return callPymbleApi(
				instance,
				"POST",
				API_END_POINT + "?request_type=" + request_type,
				{ data: request }
			);
		},
	});

	const sendToGroups = async (notification: GroupNotification) => {
		try {
			return await mutation.mutateAsync(notification);
		} catch {
			console.error("ERROR: Could not send notification to group(s).");
			return [];
		}
	};

	return {
		sendToGroups,
		notificationSending: mutation.isPending,
	};
}
